<template>
  <div>
    <el-row>
    <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6" class="hidden-xs-only">
      <!-- <el-button @click="loadDefaultsMerchants">Todos</el-button> -->
      <div v-bar class="left-bar">
        <div>
          <div class="category" v-if="categories" v-for="category in categories" :style="'background-image: url('+getAssetsUrl(category.front_image_path)+')'" @click="setCurrentCategory(category)">

            <h1><img :src="require('@/assets/img/categories/'+category.icon_light_image_path)" /> {{ category.title }}</h1>
            <!-- <p>{{ category.description }}</p> -->
          </div>
        </div>
      </div>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="center-bar">
      <GmapMap
        v-if="getCurrentMapCenter"
        ref="searchMap"
        :center="getCurrentMapCenter"
        :zoom="zoom"
        :options="{ styles: style }"
      >
        <!-- <GmapCircle
        :bounds="{}"
        :center="m.position"
        :radius="4000"
        :options="{strokeColor: '#FF0000',
              strokeOpacity: 0.2,
              strokeWeight: 1,
              fillColor: '#FF0000',
              fillOpacity: 0.20,}"
        v-for="m in markers"
        @radius_changed="updateCircle('radius', $event)"
        @bounds_changed="updateCircle('bounds', $event)">
        </GmapCircle> -->

        <GmapMarker
          v-if="m.data.categoriesMarkers[0]"
          v-for="(m, i) in filteredMarkersByCategory"
          :position="m.position"
          :clickable="true"
          @click="toggleInfoWindow(m,i)"
          :icon="{ url: require('@/assets/img/markers/'+m.data.categoriesMarkers[0]) }"
        />

        <!-- <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen">
          {{infoContent}}
        </GmapInfoWindow> -->
        <gmap-info-window v-if="getCurrentMerchant" :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
          <img @click="gotoMerchantView(getCurrentMerchant)" :src="getCurrentMerchant.logo_img_path" height="50" /><br>
          {{ getCurrentMerchant.title }}
        </gmap-info-window>
      </GmapMap>
    </el-col>
    <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6" >
      <div v-bar class="right-bar">
        <div>
          <div class="city-label">
            <h1 @click="loadDefaultsMerchants">{{ currentCity.title }}</h1>
          </div>
          <ul v-if="merchants">
            <li v-for="merchant in filteredMerchantsByCategory">
              <h2 v-if="merchant.categoriesIcons" @click="gotoMerchantView(merchant)"><img :src="require('@/assets/img/categories/'+merchant.categoriesIcons[0])" /> {{ merchant.title }}</h2>
              <i class="el-icon-phone"></i><a :href="'tel:'+merchant.phone"> {{ merchant.phone }}</a>
              <!-- <router-link :to="getMerchantViewLink(merchant)"><h3>{{ merchant.title }}</h3></router-link> -->
              <!-- <a @click="gotoMerchantView(merchant)"><h3>{{ merchant.title }}</h3></a> -->
              <p><i class="el-icon-location"></i> {{ merchant.address }}</p>
              <p><i class="el-icon-message"></i> {{ merchant.email }}</p>
            </li>
          </ul>
        </div>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
//libraries
import _ from 'lodash';

export default {
  name: "MainCityView",
  data() {
    return {
      el: '#app ul',
      effect: 'cards',
      currentCity: {},
      merchants: [],
      main_search: '',
      center: {lat:-33.457967, lng:-70.653126},
      markers: [],
      zoom: 10,
      style: require("@/assets/styles/default.json"),
      default_marker: require("@/assets/img/marker.png"),
      categories: [],
      infoWindowPos: { lat: null, lng: null },
      infoWinOpen: true,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      categorySelected: null
    };
  },
  computed: {
    querySearch(queryString, cb) {
      var merchants = this.merchants;
      var results = queryString ? merchants.filter(this.createFilter(queryString)) : merchants;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (merchant) => {
        return (_.includes(_.join(merchant.keywords), queryString.toLowerCase()));
      };
    },
    createCategoryFilter(categorySelected) { console.log(categorySelected)
      return (category) => {
        return (_.includes(_.join(category.keywords), categorySelected ));
      };
    },
    filteredMerchantsByCategory(){
      let self = this;
      return (this.categorySelected ? this.merchants.filter((merchant) => merchant.categories.find((category) => category === self.categorySelected)  ) : this.merchants);

    },
    filteredMarkersByCategory(){
      let self = this;
      return (this.categorySelected ? this.markers.filter((marker) => marker.data.categories.find((category) => category === self.categorySelected)  ) : this.markers);
    },
    getCurrentMapCenter(){
      if(this.$store.state.app){
        return this.$store.getters['app/currentMapCenter'];
      }
    },
    getCurrentMerchant(){
      if(this.$store.state.app){
        return this.$store.getters['app/currentMerchant'];
      }
    }
  },
  methods: {
    gotoMerchantView( merchant ){ //console.log(merchant)
      this.$store.dispatch("app/setMerchant", { merchant: merchant })
      .catch(error => {
        console.log(error);
      });

      // Map instance
      // this.$refs.searchMap.$mapPromise.then((map) => {
      //   var service;
      //
      //   var request = {
      //     query: 'California Cantina',
      //     fields: ['photos', 'formatted_address', 'name', 'rating', 'opening_hours', 'geometry'],
      //   };
      //
      //   service = new window.google.maps.places.PlacesService(map);
      //   service.findPlaceFromQuery(request, callbackTI);
      //
      //   function callbackTI(results, status) {
      //     if (status == window.google.maps.places.PlacesServiceStatus.OK) {
      //
      //       console.log(results)
      //       // for (var i = 0; i < results.length; i++) {
      //       //   var place = results[i];
      //       //   createMarker(results[i]);
      //       // }
      //     }
      //   }
      // })

      this.$router.push({ path: this.$route.fullPath + '/' +this.getFriendlyUrl(merchant.title) });
    },
    getFriendlyUrl(value){
      function removeAccents(str) {
        let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž.';
        let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz-";
        str = str.split('');
        str.forEach((letter, index) => {
          let i = accents.indexOf(letter);
          if (i != -1) {
            str[index] = accentsOut[i];
          }
        })
        return str.join('');
      }

      return removeAccents(value).toLowerCase().split(' ').join('-');
    },
    loadDefaultsMerchants(){
      this.categorySelected = null;
      // this.loadSidebarCategories();
      // this.loadCityLocations();
    },
    setCurrentCategory(category){
      this.categorySelected = category.id;
    },
    toggleInfoWindow(marker, idx){
      let self = this;

      self.infoWindowPos = marker.position; // Window position

      // marker.data.categoriesIcons = _.map(marker.data.categories, (category_id) => {
      //   return (_.find(self.categories, { id: category_id })).icon_name
      // });

      self.$store.dispatch("app/setMerchant", { merchant: marker.data })
      .catch(error => {
        console.log(error);
      });

      if(this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    geolocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    setCenter( city, country ) {
      let self = this;
      this.$geocoder.setDefaultMode('address');
      this.$geocoder.send({ city: city, country: country }, response => { //console.log(response.results[0])

        let country_component = _.head(_.head(response.results).address_components.filter((component) => { if(_.includes(component.types, 'country')) return component}))
        self.$store.dispatch("app/setCenterMap", response.results[0].geometry.location )
        .catch(error => {
          console.log(error);
        });
        self.$router.push({ path: self.getFriendlyUrl(country_component.long_name) + '/' +self.getFriendlyUrl(city) });
      });
    },
    getAssetsUrl(value){
      return (require('@/assets/img/'+value))? require('@/assets/img/'+value): '';
    },
    track () {
      this.$ga.page('/')
    },
    setVisibility( lang_array ) {
      if(this.$store){
        return (lang_array.indexOf(this.$store.getters['lang/getLang']) != -1) ? true:false
      }
    },
    getLang(){
      return this.$store.getters['lang/getLang']
    },
    loadSidebarCategories(){
      let self = this;

      return new Promise((resolve, reject) => {
        self.$store.dispatch('listCategories')
        .then((response) => {
          self.categories = response.data;
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject();
        });
      });

    },
    loadCityLocations(){
      let self = this;

      return new Promise((resolve, reject) => {
        self.$store.dispatch("listMerchants", { params: { city: self.currentCity.id } })
        .then(response => {
          self.merchants = response.data;
          resolve();
        }).catch(error => {
          console.log(error);
          reject();
        });
      });
    },
    setMerchants(){
      let self = this;

      _.each(self.merchants, (merchant) => {
        merchant.categoriesIcons = _.map(merchant.categories, (category_id) => {// console.log((_.find(self.categories, { id: category_id })).icon_light_image_path)
          return (_.find(self.categories, { id: category_id })).icon_light_image_path
        });
        merchant.categoriesMarkers = _.map(merchant.categories, (category_id) => {
          return (_.find(self.categories, { id: category_id })).icon_marker_image_path
        });
        self.markers.push({ position: {lat:merchant.coordinates[0], lng: merchant.coordinates[1]}, data: merchant })
      })
    },
    setCity( city, country ) {
      let self = this;
      let place_id = null;

      this.$geocoder.setDefaultMode('address');
      this.$geocoder.send({ city: city, country: country }, response => {
        let country_component = _.head(_.head(response.results).address_components.filter((component) => { if(_.includes(component.types, 'country')) return component}));

        self.$store.dispatch('app/setCurrentPlaceID', response.results[0].place_id);

        self.$store.dispatch("app/setCenterMap", response.results[0].geometry.location )
        .catch(error => {
          console.log(error);
        });

        self.$store.dispatch('getCity',{ params: { 'url_path': '/' + self.$route.params.country + '/' + self.$route.params.city } })
        .then((response) => {
          self.currentCity = response.data[0];
          self.$store.dispatch("app/setCity", { city: response.data[0] })
          .then(() => {
            Promise.all([self.loadSidebarCategories(), self.loadCityLocations()]).then(() => self.setMerchants());
          })
          .catch(error => {
            console.log(error);
          });
        })
        .catch(error => {
          console.log(error);
        });
      });

    }
  },
  created(){
    if (window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerendered) {
      return;
    }

    let self = this;

    if(this.$store.state.app){
      if(_.isEmpty(this.$store.getters['app/currentCity'])){
        self.setCity(this.$route.params.city, this.$route.params.country);
      }
      else{
        this.currentCity = this.$store.getters['app/currentCity'];
        Promise.all([this.loadSidebarCategories(), this.loadCityLocations()]).then(() => this.setMerchants());
      }
    }
    else{
      console.log('without app vars')
      // self.setCenter(item.title, item.country);
    }
  },
  filters: {
    lowercase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toLowerCase()
    }
  },
};
</script>
<style>
.el-tabs__item, .el-card{
  color: grey;
}
.left-bar{
  height: 93.9vh;
  margin-top: 60px;
  /* overflow-x: hidden;
  overflow-y: scroll; */
  box-shadow:26px 0px 31px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
  img{
    max-height: 4vh;
  }
  .el-button{ color: grey; }
  .category{

    height: 12vh;
    display: block;
    background-size: cover;
    /* transition: background-image 0.2s ease-in-out; */
    color: white;
    cursor: pointer;
    position: relative;

    &:after{
      background-color: black;
      content: '';
      opacity: 0.5;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 0;
      transition: opacity .5s ease-out;
    }

    &:hover{
      &:after{
        opacity: 0;
      }
    }

    h1{
      text-align: left;
      padding: 4.5vh 3vw;
      margin: 0;
      font-weight: 200;
      font-size: 1.4vw;
      z-index: 1;
      position: relative;

      img{
        vertical-align: middle;
      }
    }
  }
  .el-tabs__header{
    margin: 0;
  }
  .el-tabs__item, .el-tabs__item.is-active{
    color: grey;
  }
  .el-tabs__content{
    overflow: hidden scroll;
    height: 90vh;
  }
}
.center-bar{
  height: 93.9vh;
  margin-top: 60px;

  .vue-map-container{
    min-height: 100%;
  }
}
.right-bar{
  text-align: left;
  height: 93.9vh;
  margin-top: 60px;
  overflow: hidden scroll;
  box-shadow:-26px 0px 31px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
  ul{
    list-style: none;
    padding: 0;
    margin: 0;
    color: grey;
    li{
      border-bottom: solid 1px grey;
      padding: 2vh 2vw 2vh 4vw;
      position: relative;
      h2{
        color: black;
        font-size: 1.3vw;
        font-weight: 200;
        margin: 0.4vh 0;
        cursor: pointer;
        img{
          max-width: 2vw;
          position: absolute;
          left: 1vw;
          top: 2vh;
        }
      }
      p{
        margin: 0.2vh 0;
      }
    }
  }
  h2{
    font-size: 1.1vw;
  }
  .city-label{
    /* height: 2vh; */
    width: 100%;
    /* padding: 0 1vw; */
    color: white;
    background-color: #29465E;
    h1{
      text-align: center;
      padding: 2vh 4vw;
      margin: 0;
    }
  }
}
.el-menu--horizontal{
  border-bottom: none;
}
a, a:active, a:hover, a:focus, a:visited{
  color: #4c4c4c;
  text-decoration: none;
}

.gm-style-iw{
  img{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/MainCityView.vue